import { h } from 'vue'
import type { ColumnDef } from '@tanstack/vue-table'
import { ArrowUpDown, ChevronDown } from 'lucide-vue-next'
import { Button } from '@/components/ui/button'
import { format } from 'date-fns' 

export interface Booking {
  id: number;
  user: string;
  project: string;
  start: Date;
  end: Date;
  created_at: Date;
  updated_at: Date;
}

export const colsbooking = [{ key: "id", label: "ID", editable: false },
{ key: "user_id", label: "Resource", type: 'select', options: [], reference: true, editable: true, required: true },
{ key: "project_id", label: "Projekt", type: 'select', options: [], reference: true, editable: true, required: true },
{ key: "start", label: "Start", type: 'date', editable: true, required: true },
{ key: "end", label: "Ende", type: 'date', editable: true, required: true },
{ key: "created_at", label: "Erzeugt", type: 'date', editable: false, required: false },
{ key: "updated_at", label: "Geändert", type: 'date', editable: false, required: false }];
